<template>
  <div class="choose-apply">
    <RemoteSelect
      v-model="orgId"
      placeholder="请选择三方合作机构"
      :remote-method="getProviderList"
      :loading="loading"
      :clearable="clearable"
      :disabled="disabled"
      :popper-append-to-body="popperAppendToBody"
      @clear="getProviderList()"
      @visible-change="loadAllProviderList"
    >
      <el-option
        v-for="(item, index) in providerList"
        :key="index"
        :label="item.orgName"
        :value="item.orgId"
      >
      </el-option>
    </RemoteSelect>
  </div>
</template>

<script>
import common from '@/request/common';
import RemoteSelect from '@c/RemoteSelect';
export default {
  name: 'ChooseProvider',
  components: {
    RemoteSelect
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    popperAppendToBody: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      orgId: '',
      orgName: '',
      loading: false,
      providerList: []
    };
  },
  watch: {
    orgId() {
      this.getOrgName();
    }
  },
  created() {
    this.getProviderList();
  },
  methods: {
    getOrgName() {
      const indexInfo = this.providerList.find(item => item.orgId === this.orgId);
      this.orgName = indexInfo ? indexInfo.orgName : '';
    },
    async getProviderList(name) {
      const params = {
        pageNo: 1,
        pageSize: 20
      };
      name ? params.orgName = name : '';
      const res = await common.getKhOrgListApi(params);
      if (res.status === 200) {
        this.providerList = res.message.list;
      }
    },
    loadAllProviderList(val) {
      if (!val) {
        this.getProviderList();
      }
    },
    handleClear() {
      this.orgId = '';
      this.getProviderList();
    }
  }
};
</script>
